import uniq from 'lodash/uniq';
import {
  DraftDatatypeOperator,
  DraftObjectOperator,
  DraftTopExpression,
  Variable,
} from 'vet-bones/utils/queryBuilder';

import { buildThenFilter } from 'src/utils/stringify/rules/buildThenFilter';

export const buildThenClause = ({
  getVariable,
  instancesByIds,
  topExpression,
}: {
  getVariable: (variable: string, id?: string) => string;
  instancesByIds: Array<Record<string, string>>;
  topExpression: DraftTopExpression;
  isVirtual?: boolean;
}): string => {
  const triples: string[] = [];
  instancesByIds.forEach((instancesById) => {
    const getInstanceIri = (subject: Variable): string =>
      instancesById[subject.id] || '';

    topExpression.expressions.forEach(({ expressions }) =>
      expressions.forEach(({ filters }) =>
        filters.forEach((filter) => {
          const { subject, operator, value } = filter;
          if (!subject || !operator) {
            console.debug('no subject or operator for filter:', filter);
            return;
          }

          const thenFilter = buildThenFilter({
            getInstanceIri,
            getVariable,
            // no instance operator type for then filters
            operator: operator as DraftDatatypeOperator | DraftObjectOperator,
            subject,
            value,
          });
          if (thenFilter) {
            triples.push(thenFilter);
          }
        })
      )
    );
  });

  return `THEN {
  ${uniq(triples).join('\n  ')}
}`;
};
